// extracted by mini-css-extract-plugin
export default {"container":"J_-z","creativeContainer":"K_-z","copy":"L_-z","cta":"M_-z","disabled":"N_-z","flipped":"O_-z","productCard":"P_-z"};